

/// <reference path="Intermediary.ts" />

// Generated class Reseller_ManagedObject

class Reseller_ManagedObject extends Intermediary
{
}
